var RulesJS = RulesJS || {};

RulesJS.ProductMediaGallery = function() {

    let _swiper;
    let _mediaWrapper = $('.template--product .product-media__media-wrapper');

    var _init = function() {
        // let el = $('.swiper--product-media-thumbs');
        // _swiper = new Swiper(el[0], {
        //     speed: 500,
        //     loop: false,
        //     freemode: false,
        //     autoplay : false,
        //     navigation: {
        //         prevEl: ".product-media-thumb-swiper__nav-button--prev",
        //         nextEl: ".product-media-thumb-swiper__nav-button--next",
        //         disabledClass: "op-2",
        //         hiddenClass: "op-1"
        //     },
        //     slidesPerView: 4,
        //     spaceBetween: 20,
        //     centerInsufficientSlides: true,
        // });

        // initiate image zoom
        _mediaWrapper.zoom({
            "url" : _mediaWrapper.find('img:first-child').data('og-img')
        });

        $('.product-media__thumb').on('click', function(e) {
            e.preventDefault();
            let thumb = $(this);
            let target = $(thumb.attr('href'));

            // get currently active media
            let currentMedia = $('.product-media__media.active');
            let currentMediaType = currentMedia.prop("tagName").toLowerCase();
            currentMedia.removeClass('active').addClass('d-none');
            if (currentMediaType !== 'video') {
                _mediaWrapper.trigger('zoom.destroy');
            }

            // get next media to activate
            let nextMediaType = target.prop("tagName").toLowerCase();
            target.removeClass('d-none').addClass('active');
            if (nextMediaType === 'img') {
                _mediaWrapper.zoom({'url' : target.data('og-img')});
            }
            
            // active status
            $('.product-media__thumb').removeClass('active');
            thumb.addClass('active');
            
        });

    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
    };

}();

$(function() {
    RulesJS.ProductMediaGallery.init();
});
